import { SEARCH_PROPERTY_STATUS_FOR_RENT_VALUE } from '../types';

export const isPropertyStatusForRent = (status: string | undefined): boolean =>
  status === SEARCH_PROPERTY_STATUS_FOR_RENT_VALUE;
